export default "__VITE_ASSET__BO$GcZw7__"